import React from 'react';
import Svg, { Defs, G, Path, Line, Circle } from 'react-native-svg';

export default function CheckMark(props) {
    return (
        <Svg
            xmlns="http://www.w3.org/2000/svg"
            width="32.035"
            height="32.035"
            viewBox="0 0 32.035 32.035">
            <G id="Group_1110" transform="translate(-2182.421 -1461.351)">
                <Circle
                    id="Ellipse_50"
                    cx="16.018"
                    cy="16.018"
                    r="16.018"
                    transform="translate(2182.421 1461.351)"
                    fill="#2b4480"
                />
                <G id="Group_1109">
                    <Line
                        id="Line_249"
                        x2="5.052"
                        y2="6.005"
                        transform="translate(2190.658 1477.944)"
                        fill="none"
                        stroke="#fff"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="3"
                    />
                    <Line
                        id="Line_250"
                        y1="11.835"
                        x2="10.046"
                        transform="translate(2195.71 1472.114)"
                        fill="none"
                        stroke="#fff"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="3"
                    />
                </G>
            </G>
        </Svg>
    );
}
